export default __webpack_public_path__ + "static/media/Noe Text Regular.d1138f3f.otf";